import type { SVGProps } from 'react';
export const Edit = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M14.52 4.35a1.1 1.1 0 0 0-.8.33l-.58.59 1.6 1.59.58-.58a1.13 1.13 0 0 0-.8-1.93m-.74 3.47-1.6-1.6-6.94 6.95-.6 2.19 2.2-.6zm-.21-4.63a2.48 2.48 0 0 1 2.7 4.05l-8.6 8.6a1 1 0 0 1-.3.18l-3.51.96a.68.68 0 0 1-.84-.84l.96-3.5q.05-.18.18-.3l8.6-8.61q.35-.35.8-.54"
      clipRule="evenodd"
    />
  </svg>
);
